
import Big from 'big.js'

import { makeUUID } from '$lib/factories'

import type { Item, ItemFull } from './types'



export function makeItemWithId( values?: Item | null ): Item {
	const newData = makeItem(values)
	newData.id = makeUUID()
	return newData
}


export function makeItem( values?: Item | null ): Item {
	
	let newData: Item = {
		id: '',
		category_id: null,
		subcategory_id: null,
		name: '',
		details: '',
		sku: '',
		cost: Big(0),
		price: Big(0),
		taxable: true,
		archived: false
	}
	newData = { ...newData, ...values }
	return newData
}

export function makeItemFull( values?: Partial<ItemFull> | null): ItemFull {
	let newData: ItemFull = {
		...makeItem(),
		taxes: []
	}
	newData = { ...newData, ...values }
	return newData

}